// The store operates in several countries out of one backend database with
// shared users. The dashboard serves each country under its own path prefix
// (portal.eilik.com/sa, /kw, ...) and sends the code as the X-Country header.

export type CountryCode = 'SA' | 'KW' | 'QA' | 'OM' | 'AE' | 'BH'

export type CountryCurrency = {
  code: string
  symbol_en: string
  symbol_ar: string
  decimals: number
}

export type Country = {
  code: CountryCode
  name: string
  name_ar: string
  flag: string
  dial_code: string
  mobile_length: number

  // VAT % used when an order has no stored breakdown (same defaults as the backend)
  default_vat: number
  currency: CountryCurrency
}

export const DEFAULT_COUNTRY_CODE: CountryCode = 'SA'

export const COUNTRIES: Record<CountryCode, Country> = {
  SA: {
    code: 'SA',
    name: 'Saudi Arabia',
    name_ar: 'السعودية',
    flag: '🇸🇦',
    dial_code: '966',
    mobile_length: 9,
    default_vat: 15,
    currency: { code: 'SAR', symbol_en: 'SAR', symbol_ar: 'ر.س', decimals: 2 }
  },
  KW: {
    code: 'KW',
    name: 'Kuwait',
    name_ar: 'الكويت',
    flag: '🇰🇼',
    dial_code: '965',
    mobile_length: 8,
    default_vat: 0,
    currency: { code: 'KWD', symbol_en: 'KWD', symbol_ar: 'د.ك', decimals: 3 }
  },
  QA: {
    code: 'QA',
    name: 'Qatar',
    name_ar: 'قطر',
    flag: '🇶🇦',
    dial_code: '974',
    mobile_length: 8,
    default_vat: 0,
    currency: { code: 'QAR', symbol_en: 'QAR', symbol_ar: 'ر.ق', decimals: 2 }
  },
  OM: {
    code: 'OM',
    name: 'Oman',
    name_ar: 'عُمان',
    flag: '🇴🇲',
    dial_code: '968',
    mobile_length: 8,
    default_vat: 5,
    currency: { code: 'OMR', symbol_en: 'OMR', symbol_ar: 'ر.ع', decimals: 3 }
  },
  AE: {
    code: 'AE',
    name: 'UAE',
    name_ar: 'الإمارات',
    flag: '🇦🇪',
    dial_code: '971',
    mobile_length: 9,
    default_vat: 5,
    currency: { code: 'AED', symbol_en: 'AED', symbol_ar: 'د.إ', decimals: 2 }
  },
  BH: {
    code: 'BH',
    name: 'Bahrain',
    name_ar: 'البحرين',
    flag: '🇧🇭',
    dial_code: '973',
    mobile_length: 8,
    default_vat: 10,
    currency: { code: 'BHD', symbol_en: 'BHD', symbol_ar: 'د.ب', decimals: 3 }
  }
}

export const COUNTRY_CODES = Object.keys(COUNTRIES) as CountryCode[]
